module.exports = __webpack_public_path__ + "static/media/Down.4b3dd14b.svg";